export default "__VITE_ASSET__quiIqAOz__"